import * as yup from 'yup';

export const editMetricsSchema = yup.object().shape({
  tab: yup.string(),
  metrics_edit: yup.object().shape({
    values: yup.object().shape({}),
    descriptions: yup.object().shape({}),
  }),
});
